const toStoredUser = (user: any) => {
  if (!user || typeof user !== "object") return user;
  const { mustChangePassword, ...safeUser } = user;
  return { ...safeUser, credentialRotationRequired: Boolean(mustChangePassword) };
};

const fromStoredUser = (user: any) => {
  if (!user || typeof user !== "object") return user;
  const { credentialRotationRequired, ...safeUser } = user;
  return { ...safeUser, mustChangePassword: Boolean(credentialRotationRequired) };
};

export const getUser  = () => { try { return fromStoredUser(JSON.parse(localStorage.getItem("cc_user") || "null")); } catch { return null; } };
export const setAuth  = (u: any) => { localStorage.setItem("cc_user", JSON.stringify(toStoredUser(u))); };
export const clearAuth = () => { localStorage.removeItem("cc_user"); localStorage.removeItem("cc_token"); localStorage.removeItem("cc_refresh_token"); };

export const setAuthFromResponse = (payload: Record<string, unknown>) => {
  const user = payload.user;
  if (!user) throw new Error("Invalid auth response");
  setAuth(user);
  return user as { mustChangePassword?: boolean };
};
